import { v4 as uuidv4 } from 'uuid'
import type { BoxColorConfig, StoryBox } from './types'

// FR-2.2: Lighter gradient palette (100/200 tones) for better readability
// Order: Blue → Purple → Green → Orange → Pink (cycles for 5+ boxes)
export const BOX_COLORS: BoxColorConfig[] = [
  {
    name: 'Blue',
    gradient: 'from-blue-200/30 to-blue-300/20',
    border: 'border-blue-300/50',
    text: 'text-blue-200',
    badgeBg: 'bg-blue-500'
  },
  {
    name: 'Purple',
    gradient: 'from-purple-200/30 to-purple-300/20',
    border: 'border-purple-300/50',
    text: 'text-purple-200',
    badgeBg: 'bg-purple-500'
  },
  {
    name: 'Green',
    gradient: 'from-green-200/30 to-green-300/20',
    border: 'border-green-300/50',
    text: 'text-green-200',
    badgeBg: 'bg-green-500'
  },
  {
    name: 'Orange',
    gradient: 'from-orange-200/30 to-orange-300/20',
    border: 'border-orange-300/50',
    text: 'text-orange-200',
    badgeBg: 'bg-orange-500'
  },
  {
    name: 'Pink',
    gradient: 'from-pink-200/30 to-pink-300/20',
    border: 'border-pink-300/50',
    text: 'text-pink-200',
    badgeBg: 'bg-pink-500'
  }
]

// Position-specific placeholder text for each box (FR-3.2)
// Guides songwriters through the narrative arc structure
export const BOX_PLACEHOLDERS: Record<number, string> = {
  1: 'Set the scene: Where are we? Who\'s involved? What\'s the status quo before change arrives?',
  2: 'Introduce tension: What shifts the balance? A discovery, conflict, or turning point...',
  3: 'Deepen the stakes: What are the consequences? How does the protagonist respond?',
  4: 'Escalation or revelation: What pushes things to the limit? A climax, confession, or truth unveiled...',
  5: 'Resolution: Where do we land? Acceptance, transformation, or a new beginning?'
}

// Character count threshold for showing warning (FR-3.4)
export const CHAR_COUNT_THRESHOLD = 500

export const MIN_BOXES = 1
export const MAX_BOXES = 5
export const DEFAULT_BOX_COUNT = 3
// 500ms debounce gives users time to finish typing before auto-save
// Matches FR-3.3 blur-flush behavior requirement
export const DEBOUNCE_DELAY = 500

// Default boxes for new songs - 3 empty boxes to start
export function createDefaultBoxes(): StoryBox[] {
  return Array.from({ length: DEFAULT_BOX_COUNT }, (_, index) => ({
    id: uuidv4(),
    order: index + 1,
    content: ''
  }))
}
